import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, QrCode, Mic, Headphones, ArrowRight } from 'lucide-react';
interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function HowItWorksModal({
  isOpen,
  onClose
}: HowItWorksModalProps) {
  const steps = [{
    icon: QrCode,
    number: '1',
    title: 'Share Your QR Code',
    description: 'Display your unique QR code at the venue. Guests scan it with their phone — no app download needed.'
  }, {
    icon: Mic,
    number: '2',
    title: 'Guests Record Messages',
    description: "They tap record, say what's on their heart, and hit save. It takes less than a minute."
  }, {
    icon: Headphones,
    number: '3',
    title: 'Listen & Download',
    description: 'Every message lands in your Ihsanly dashboard. Listen, download, and relive the love anytime.'
  }];
  return <AnimatePresence data-id="element-206">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center px-4" data-id="element-207">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-208" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.4,
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="relative w-full max-w-lg bg-brown-700 rounded-3xl shadow-2xl overflow-hidden border border-white/10" data-id="element-209">
            <div className="h-1.5 bg-gradient-to-r from-accent-purple to-accent-pink" data-id="element-210" />

            <button onClick={onClose} className="absolute top-5 right-5 w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors text-cream-400 hover:text-white" data-id="element-211">
              <X size={16} data-id="element-212" />
            </button>

            <div className="p-8 md:p-10" data-id="element-213">
              <h2 className="text-3xl font-serif italic text-white mb-2" data-id="element-214">
                How It Works
              </h2>
              <p className="text-cream-400 text-sm leading-relaxed mb-8" data-id="element-215">
                Three simple steps to capture every heartfelt message at your
                wedding.
              </p>

              <div className="space-y-6" data-id="element-216">
                {steps.map((step, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.1 + i * 0.15,
              duration: 0.4
            }} className="flex items-start space-x-4" data-id="element-217">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-accent-purple to-accent-pink flex items-center justify-center flex-shrink-0 relative" data-id="element-218">
                      <step.icon className="w-5 h-5 text-white" data-id="element-219" />
                      <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-white text-accent-pink text-xs font-bold flex items-center justify-center" data-id="element-220">
                        {step.number}
                      </span>
                    </div>
                    <div data-id="element-221">
                      <h3 className="text-white font-bold mb-1" data-id="element-222">
                        {step.title}
                      </h3>
                      <p className="text-cream-400 text-sm leading-relaxed" data-id="element-223">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>)}
              </div>

              <div className="mt-8 pt-6 border-t border-white/10 text-center" data-id="element-224">
                <p className="text-cream-400 text-sm mb-4" data-id="element-225">
                  Ready to get started?
                </p>
                <button onClick={onClose} className="bg-gradient-to-r from-accent-purple to-accent-pink text-white text-sm font-bold tracking-widest uppercase px-8 py-3 rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300 inline-flex items-center space-x-2 group" data-id="element-226">
                  <span data-id="element-227">Got It</span>
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-228" />
                </button>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}